define('drops/carouselTabControl/carouselTabControl',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util'
], function ($, _, Drop, Style, util) {
    'use strict';

    var defaults = {
        data: {
            type: 'CarouselTabControl'
        }
    };

    function CarouselTabControl(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;
        this.onChangeFunc = function (index) {
            self.$element.find('.carousel-tab-control-tab').eq(index).trigger('click');
        };
    }

    Drop.extend(CarouselTabControl, Drop);

    CarouselTabControl.typeName = 'CarouselTabControl';

    CarouselTabControl.prototype.getCarousel = function () {
        return this.data.carousel && this.piping.dropFactory.findDropByName(this.data.carousel);
    };

    CarouselTabControl.prototype.getTabData = function () {
        if (!this.carousel)
            return [];
        return _.chain(this.carousel.childDrops)
            .pluck('data')
            .where({ type: 'CarouselPanel' })
            .value();
    };

    CarouselTabControl.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        this.carousel = this.getCarousel();
        this.applyPosition();
    };

    CarouselTabControl.prototype.postRender = function () {
        this.renderTabs();
    };

    CarouselTabControl.prototype.renderTabs = function () {
        var self = this;
        this.carousel = this.getCarousel();

        _.each(this.getTabData(), function (tabData, index) {
            var $tab = $('<div />')
                .text(tabData.name)
                .width(self.data.tabX)
                .height(self.data.tabY)
                .addClass('boxToBorderSize')
                .addClass('carousel-tab-control-tab')
                .css({
                    cursor: 'pointer',
                    'float': 'left',
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                    display: 'block',
                    lineHeight: 1
                })
                .appendTo(self.$element);

            Style.renderStyles(self, null, $tab);

            if (index === self.carousel.getInitialIndex()) {
                self.selectedTab = index;
                $tab.addClass('active');
            }
            $tab.on('click', function () {
                self.carousel.goToSlide(index);
                $(this).addClass('active').siblings().removeClass('active');
            });
        });
        if (this.carousel) {
            this.carousel.onChange(this.onChangeFunc);
        }
    };

    return CarouselTabControl;
});
